import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
export const ElementAreaWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.white};
`;
